import "../../../../../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22..%2Fcore%2Fweb%2Fsrc%2Fslate-labs%2FCarousel%2F__internal__%2FcarouselStyles.css.ts.vanilla.css%22%2C%22source%22%3A%22%23H4sIAAAAAAAAA8WT627iMBCF%2F%2FcpRlpVitt1N4FAqCut9lVMbBK3jp1NXAhd9d1XcVJITIAIgWok5Muc45nxl6fYvC9zvYbfwET9X64T%2BHcHUJpCv3ECa1p4GDdRPnq5A4i11MXhwefdU8%2BLpHrNizOOwTHHoOdImCjpUnJ2NM0f0az%2Bddx2OzubrVVsBDMpgcD37%2BvoXJfCCK0IFFxSI9a8owh8K6kLWUm9IZAKxriqdSkXSWq%2BfPaKwCqOnU7saSYUbtPwu6dT9zSjFY61MlyZOu5PxpmgUMYF5wqoYuB1gqP5Iq8QWI%2FdU9SLbpF0WWr5bviL3Tc6JzBrGgHwgYVivCIQ1OvPvc2mtZF8ZWzKVltQVa50kZFmKqnhXkxl7Hl11fDYe88JQvAAOEA%2FAc%2F8e%2BTcULU3FE3bzl4xfEPPe7hdtNq3K3Lbtf1qF2VMqAQ39QbzvHLS%2FWgDmShzSbcEVpJXTc5UikRhYXhWEoi5MrxwxC0EYEUEfPDB1mT36rGf1cOWintbbkg9uq2gCB4OAoZErnCOAEMAj4OB%2FdAMjQr7iwaC3L3uGsGvzqqfcteYI%2Bf9xWFC%2FdK6l7RzF8MgbJ8mo0UiFG5x7Pf2FF4HX6NLXeBPpi52h0C06V0Zi%2BdLsZiNx0KOwyK%2FFRbMxSI9jcVsHBZEaeMRSUuD41RIhs5y8jxgstcPyu1zuw%2FWMzVoJH2BPwm%2FC7PFpZiF4zF7G4eZvhVmsYtZchqz8FaYLa6A2cLFrByNWRj634VZdClm0%2FGYvY7DTN0Ks6WL2eo0ZtNbYRZdAbPIxazYYfYf9NesxIYMAAA%3D%22%7D"
export var carouselWrapperStyles = 'ctubpoy';
export var iconButtonSyles = 'ctubpov';
export var innerContainerStyles = 'ctubpo11';
export var nextButtonStyles = 'ctubpox';
export var outerContainerStyles = 'ctubpo10';
export var previousButtonStyles = 'ctubpow';
export var showArrowButtonsStyles = 'ctubpoz';
export var slideStylesGap = 'ctubpo14';
export var slideStylesWidthFixed = 'ctubpo12';
export var slideStylesWidthFreeFlow = 'ctubpo13';
export var varArrowColor = 'var(--ctubpo0)';
export var varArrowColorHover = 'var(--ctubpo1)';
export var varArrowOffsetX = 'var(--ctubpo2)';
export var varHasPeekNextDesktop = 'var(--ctubpok)';
export var varHasPeekNextMobile = 'var(--ctubpom)';
export var varHasPeekNextTablet = 'var(--ctubpol)';
export var varHasPeekNextXLarge = 'var(--ctubpoj)';
export var varHasPeekPreviousDesktop = 'var(--ctubpoo)';
export var varHasPeekPreviousMobile = 'var(--ctubpoq)';
export var varHasPeekPreviousTablet = 'var(--ctubpop)';
export var varHasPeekPreviousXLarge = 'var(--ctubpon)';
export var varItemGapDesktop = 'var(--ctubpo8)';
export var varItemGapMobile = 'var(--ctubpoa)';
export var varItemGapTablet = 'var(--ctubpo9)';
export var varItemGapXLarge = 'var(--ctubpo7)';
export var varItemPerSlideDesktop = 'var(--ctubpo4)';
export var varItemPerSlideMobile = 'var(--ctubpo6)';
export var varItemPerSlideTablet = 'var(--ctubpo5)';
export var varItemPerSlideXLarge = 'var(--ctubpo3)';
export var varLoopDesktop = 'var(--ctubpos)';
export var varLoopMobile = 'var(--ctubpou)';
export var varLoopTablet = 'var(--ctubpot)';
export var varLoopXLarge = 'var(--ctubpor)';
export var varPeekNextDesktop = 'var(--ctubpoc)';
export var varPeekNextMobile = 'var(--ctubpoe)';
export var varPeekNextTablet = 'var(--ctubpod)';
export var varPeekNextXLarge = 'var(--ctubpob)';
export var varPeekPreviousDesktop = 'var(--ctubpog)';
export var varPeekPreviousMobile = 'var(--ctubpoi)';
export var varPeekPreviousTablet = 'var(--ctubpoh)';
export var varPeekPreviousXLarge = 'var(--ctubpof)';